export default {
    to: "/dashboard/waas/",
    order: 3,
    icon: "mdi-credit-card-clock",
    title: "Utility Payments",
    disabled: false,
    value: 0,
    sublinks: [
        {
            to: "/dashboard/waas/utility-payments/purchase-airtime",
            order: 3,
            icon: "mdi-contactless-payment-circle-outline",
            title: "Purchase Airtime",
            disabled: false,
            value: 0,
        },
        {
            to: "/dashboard/waas/utility-payments/purchase-kplc-tokens",
            order: 3,
            icon: "mdi-contactless-payment-circle",
            title: "Purchase KPLC Tokens",
            disabled: false,
            value: 0,
        },
        {
            to: "/dashboard/waas/utility-payments/post-paid-bills",
            order: 3,
            icon: "mdi-post",
            title: "Post Paid Bills",
            disabled: false,
            value: 0,
        },
        {
            to: "/dashboard/waas/utility-payments/tv",
            order: 3,
            icon: "mdi-youtube-tv",
            title: "Pay TV",
            disabled: false,
            value: 0,
        },
    ]
}
